import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import {DefaultsLayout} from '../Layout';

function DefaultsTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    return (
            <FormField
                currrentUser={currentUser}
                layoutId='AC028D08-B2EE-4217-B510-8B132D65212F'
                layoutName='OMTransactionprofileDefaultsForm'
                defaultFormSchema={DefaultsLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.handleDefaultsFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(DefaultsTab);
